module.exports = __webpack_public_path__ + "static/media/badge_special.99488c23.png";